import React from "react";

const Footer = () => {
	return (
		<div className="footer">
			<span>
				App created by{" "}
				<a
					href="https://hnbuilds.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					HN Builds
				</a>
			</span>
		</div>
	);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js